<template>
    <div class="content">
        <div class="caseBox" v-if="caseData">
            <div class="textItem">
                <div class="titleBox">
                    <div class="title">
                        <div class="section-num">1</div>
                        主诉
                    </div>
                    <div class="cobyBtn" @click="copyData(caseData.chief_complaint)">
                        📋 复制
                    </div>
                </div>
                <div class="textBox" v-html="caseData.chief_complaint" v-mathjax></div>
            </div>
            <div class="textItem">
                <div class="titleBox">
                    <div class="title">
                        <div class="section-num">2</div>
                        现病史
                    </div>
                    <div class="cobyBtn" @click="copyData(caseData.present_illness)">
                        📋 复制
                    </div>
                </div>
                <div class="textBox" v-html="caseData.present_illness" v-mathjax></div>
            </div>
            <div class="textItem">
                <div class="titleBox">
                    <div class="title">
                        <div class="section-num">3</div>
                        既往史
                    </div>
                    <div class="cobyBtn" @click="copyData(caseData.past_history)">
                        📋 复制
                    </div>
                </div>
                <div class="textBox" v-html="caseData.past_history" v-mathjax></div>
            </div>
            <div class="textItem">
                <div class="titleBox">
                    <div class="title">
                        <div class="section-num">4</div>
                        检查结果
                    </div>
                    <div class="cobyBtn" @click="copyData(caseData.examinations)">
                        📋 复制
                    </div>
                </div>
                <div class="textBox" v-html="caseData.examinations" v-mathjax></div>
            </div>
            <div class="textItem">
                <div class="titleBox">
                    <div class="title">
                        <div class="section-num">5</div>
                        诊断
                    </div>
                    <div class="cobyBtn" @click="copyData(caseData.diagnosis)">
                        📋 复制
                    </div>
                </div>
                <div class="textBox" v-html="caseData.diagnosis" v-mathjax></div>
            </div>
            <div class="textItem">
                <div class="titleBox">
                    <div class="title">
                        <div class="section-num">6</div>
                        医嘱
                    </div>
                    <div class="cobyBtn" @click="copyData(caseData.medical_orders)">
                        📋 复制
                    </div>
                </div>
                <div class="textBox" v-html="caseData.medical_orders" v-mathjax></div>
            </div>
        </div>

        <div class="contentBox" v-if="content" style="">
                {{ content }}
        </div>
        
        <!-- 侧边栏 -->
        <div class="sidebarBox2">
			<div class="topBox">
				<div class="sidebarTitleBox">
					<div class="sidebarTitle">病历助手</div>
				</div>
                <div class="addBtnBox" @click="jumpwebAiVoiceInput()">
                    <img class="addImg" src="../assets/images/webAiIcon5-1.png" alt="">
                    <div class="addTitle">新建对话</div>
                </div>
			</div>
			<div class="historyList">
				<div class="historyListItem" v-for="(item, index) in historyDataList" :key="index"
					@click="getFromatCase(item)">
					<div :class="index < 3?'historyItem bottom':'historyItem'">
						<div class="text">
							{{ item.case_title }}
						</div>
						<input :ref="'myInput' + index + index" type="text" v-show="item.inpOff" class="editInp"
							v-model="item.case_title" @blur="updateCaseTitle(item)">
						<img class="openBtn" @click.stop="item.editOff = true" src="../assets/images/webAiIcon6.png"
							alt="">
						<div class="bgi" v-show="item.editOff" @click.stop="item.editOff = false"></div>
						<div class="bgi" v-show="item.inpOff" @click.stop="item.inpOff = false"></div>
						<div class="deleteBox" v-show="item.editOff">
							<div class="btnItem" @click.stop="onEdit(item, index + '' + index)">
								<img class="btnIcon" src="../assets/images/editIcon.png" alt="">
								重命名
							</div>
							<div class="btnItem" @click.stop="deleteCase(item)">
								<img class="btnIcon" src="../assets/images/deleteIcon.png" alt="">
								删除
							</div>
						</div>
					</div>
				</div>
				<div class="" v-show="historyDataList.length == 0">
					暂无搜索
				</div>
			</div>
            <div class="btmBox" style="height: 100px;padding-top: 20px;">
                <div class="appBtn" @click="downloadAPP()">
                    <img class="logoIcon" src="../assets/images/logoIcon.png" alt="">
                    下载宠医客APP
                </div>
            </div>
            <div class="btmBox">
                <img class="userImg"
                    :src="loginInfo.HeadPortrait ? loginInfo.HeadPortrait : require('../assets/images/webAiUserIcon.png')"
                    alt="">
                {{ loginInfo.name }}
            </div>
        </div>
    </div>
</template>

<script>
import { marked } from 'marked';
export default {
    data() {
        return {
            imgSrc: "https://case.chongyike.com",
            // 关键词
            caseText: "",
            // 诊断数据
            caseData: {},
            // 历史记录列表
            historyDataList: [],
            messageId: "",
            // 用户信息
            loginInfo: {},
            // 没有生成病历的字段
            content: ""
        };
    },
    created() {
        const that = this
        if(localStorage.getItem("toText")){
            // 通过录音页面进入
            that.caseText = localStorage.getItem("toText")
            localStorage.removeItem("toText")
            that.textToFormatDecisionMaing()
        }else if(localStorage.getItem("messageId")){
            // 通过历史记录进入
            that.messageId = localStorage.getItem("messageId")
            that.getFromatCase()
            that.getCaseList()
        }
        if (that.Cookies.get("loginInfo")) {
            that.loginInfo = JSON.parse(that.Cookies.get("loginInfo"))
        }
    },

    methods: {
        // 跳转病历助手
        jumpwebAiVoiceInput(){
            this.$router.push({
                path: '/webAiVoiceInput',
            })
        },
		
        // 点击重命名
        onEdit(item, index) {
            item.inpOff = true
            item.editOff = false
            var a = 'myInput' + index
            this.$nextTick(() => {
                if (this.$refs[a]) {
                    this.$refs[a][0].focus();
                }
            })
        },
        // 重命名方法
        updateCaseTitle(item) {
            const that = this
            item.inpOff = false
            var data = {
                type: 'updateCaseTitle',
                messageId: item.message_id,
                newName: item.case_title
            }
            this.get("/ai/decisionMaking2", data, 1).then((res) => {
                if (res.data.code == "success") {
				}else {
					that.$message({
						showClose: true,
						message: res.data.message,
					});
				}
            })
        },
        // 删除历史记录
        deleteCase(item) {
            const that = this
            item.inpOff = false
            var data = {
                type: 'deleteCase',
                messageId: item.message_id,
            }
            this.get("/ai/decisionMaking2", data, 1).then((res) => {
                if (res.data.code == "success") {
                    var result = res.data.result
                    that.getCaseList()
                    that.$message({
                        showClose: true,
                        message: res.data.message,
                    });
                }
            })
        },
        // 生成病历展示
        textToFormatDecisionMaing() {
            const that = this
            that.content = ''
            that.caseData = ''
            const loading = this.$loading({
                lock: true,
                text: '生成病历中，请稍等',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            var data = {
                type: 'textToFormatDecisionMaing',
            }
            const formData = new FormData();
            formData.append('caseText', that.caseText);
            this.post("/ai/decisionMaking2", data, formData).then((res) => {
                loading.close();
                if (res.data.code == "success") {
                    var result = JSON.parse(res.data.result)
                    localStorage.setItem("messageId",result.message_id)
                    if(result.format){
                        var format = JSON.parse(result.format)
                        for (const key in format) {
                            if (Object.hasOwnProperty.call(format, key)) {
                                format[key] = marked(format[key]).replace(/<del>|<\/del>/g, "")
                            }
                        }
                        that.caseData = format
                    }else {
                        that.content = result.content
                    } 
                    that.getCaseList()
                } else {
                    that.$message({
                        showClose: true,
                        message: res.data.message,
                        type: 'error'
                    });
                }
            })
        },
		// 获取历史记录列表
		getCaseList(){
			const that = this
            var data = {
                type: 'getCaseList',
            }
            this.get("/ai/decisionMaking2", data).then((res) => {
                if (res.data.code == "success") {
                    var result = res.data.result
					for (let i = 0; i < result.length; i++) {
						result[i].inpOff = false
						result[i].editOff = false
					}
					that.historyDataList = result
                }else {
					that.$message({
						showClose: true,
						message: res.data.message,
					});
				}
            })
		},
        // 获取某一条历史记录
        getFromatCase(item){
            const that = this
            if(item){
                if(that.messageId == item.message_id){
                    return false
                }else {
                    that.messageId = item.message_id
                }
            }
            that.content = ""
            that.caseData = ""
            var data = {
                type: 'getFromatCase',
                messageId: that.messageId
            }
            this.get("/ai/decisionMaking2", data, 1).then((res) => {
                if (res.data.code == "success") {
                    var result = res.data.result
                    if(result.format){
                        var format = JSON.parse(result.format)
                        for (const key in format) {
                            if (Object.hasOwnProperty.call(format, key)) {
                                format[key] = marked(format[key]).replace(/<del>|<\/del>/g, "")
                            }
                        }
                        that.caseData = format
                    }else {
                        that.content = result.content
                    }
                } else {
                    that.$message({
                        showClose: true,
                        message: res.data.message,
                        type: 'error'
                    });
                }
            })
        },
        // 复制
        copyData(data) {
            const that = this
            const el = document.createElement('textarea');
            // 将需要复制的文本内容赋值给 textarea 元素。
            // el.value = data.markedText;
            el.value = data.replace(/\<.*?\>/g, '');;
            //将 textarea 元素添加到页面中。
            document.body.appendChild(el);
            //选中 textarea 元素中的文本。
            el.select();
            // 执行复制命令，将选中的文本复制到剪贴板
            document.execCommand('copy');
            //从页面中移除 textarea 元素。
            document.body.removeChild(el);
            //弹出提示框，告知用户文本已复制成功。
            this.$message.success("复制成功")
        },
    }
}
</script>

<style scoped lang="scss">
.content {
    display: flex;
    align-items: center;
    flex-direction: column;
    margin: 0 !important;
    width: 100vw !important;
    padding-left: 240px;
    box-sizing: border-box;
}
.contentBox {
    padding-top: 40vh;
    box-sizing: border-box;
}
.textItem {
    width: 820px;
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 10px;
    padding: 24px 28px;
    margin-bottom: 16px;

    .titleBox {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 10px;
        margin-bottom: 14px;
        padding-bottom: 12px;
        border-bottom: 1px solid #e5e7eb;

        .title {
            display: flex;
            align-items: center;
            font-size: 16px;
            font-weight: 700;
            color: #1f2937;

            .section-num {
                width: 28px;
                height: 28px;
                border-radius: 7px;
                background: #1a6db5;
                color: #fff;
                font-size: 13px;
                font-weight: 700;
                display: flex;
                align-items: center;
                justify-content: center;
                flex-shrink: 0;
                margin-right: 10px;
            }
        }
        .cobyBtn {
            font-size: 12px;
            color: #1f2937;
            cursor: pointer;
            &:hover {
                color: #1a6db5;
            }
        }

    }
    .textBox {
        font-size: 15px;
        color: #1f2937;
    }
}


.sidebarBox2 {
	position: fixed;
	left: 0;
	top: 0;
	width: 60px;
	height: 100vh;
	user-select: none;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	background: linear-gradient(#ebf6ff, #f1f9ff, #f9fcff, #fff);
	width: 240px;
	padding: 20px 0;
	box-sizing: border-box;
	background-color: #f2f3ff;

	.topBox {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;

		.sidebarTitleBox {
			display: flex;
			justify-content: space-between;
			align-items: center;
			width: 100%;
			padding: 0 15px;
			box-sizing: border-box;

			.sidebarTitle {
				font-size: 22px;
				// font-weight: 600;
			}

			.offBtn {
				width: 26px;
				cursor: pointer;
			}
		}

		.addBtnBox {
			display: flex;
			align-items: center;
			justify-content: center;
			padding: 10px 20px 10px;
			margin: 20px 0 10px;
			box-sizing: border-box;
			background-color: #fff;
			color: #333;
			border-radius: 5px;
			width: 200px;
			cursor: pointer;

			&:hover {
				box-shadow: 0 0 5px 0px #5ea4f7;
			}
			.addImg {
				width: 16px;
				padding-right: 5px;
			}

			.addTitle {
				font-size: 16px;
			}
		}
	}

	.historyList {
		overflow: auto;
		padding: 0px 10px 20px;
		min-height: 70vh;
		box-sizing: border-box;

		.historyListItem {
			display: flex;
			align-items: center;
			padding: 3px 3px;
			font-size: 14px;
			color: #333;
			cursor: pointer;

			&:hover {
				color: #155a8a;
				border-radius: 5px;
				// border: 1px solid #d5dfff;
				background-color: #eff6ff;
			}

			.historyItem {
				position: relative;
				display: flex;
				align-items: center;
				border-radius: 5px;
				// border: 1px solid #f2f3ff;
				cursor: pointer;

				&:hover {
					border-radius: 5px;
					// border: 1px solid #d5dfff;
					background-color: #eff6ff;

					.openBtn {
						display: block;
					}
				}

				.text {
					width: 192px;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
					height: 28px;
					line-height: 28px;
					padding: 0 5px;
					padding-right: 30px;
					font-size: 14px;
					box-sizing: border-box;
				}

				.editInp {
					position: absolute;
					top: 0;
					left: 0;
					width: 100%;
					height: 30px;
					padding: 0 5px;
					z-index: 4;
					box-sizing: border-box;
					background-color: #fff;
					border: none;
					user-select: none;
					outline: none;
				}

				.openBtn {
					position: absolute;
					display: none;
					top: 3px;
					right: 10px;
					width: 20px;
				}

				.bgi {
					position: fixed;
					left: 0;
					top: 0;
					width: 100vw;
					height: 100vh;
					z-index: 2;
					background-color: rgba(0, 0, 0, .0);
				}

				.deleteBox {
					position: absolute;
					right: 0;
					bottom: 0;
					padding: 10px;
					transform: translateY(-50%);
					border-radius: 5px;
					box-shadow: 0 0 10px #ccc;
					background-color: #fff;
					z-index: 3;

					.btnItem {
						display: flex;
						align-items: center;
						color: #ff3642;

						&:nth-child(1) {
							color: #636363;
							margin-bottom: 10px;
						}

						.btnIcon {
							width: 20px;
							margin-right: 5px;
						}
					}
				}
			}
			.bottom {
                    .deleteBox {
                        transform: translateY(100%);
                    }
                }

		}
	}

	.btmBox {
		display: flex;
		align-items: center;
		// justify-content: center;
		// width: 300px;
		width: 100%;
		padding: 20px 15px 20px;
		font-size: 18px;
		box-sizing: border-box;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;

		.userImg {
			width: 35px;
			border-radius: 50%;
			margin-right: 5px;
		}

		.appBtn {
			display: flex;
			align-items: center;
			padding: 5px 8px;
			border-radius: 10px;
			font-size: 15px;
			color: #333;
			border: 1px solid #5ea4f7;
			user-select: none;
			cursor: pointer;

			.logoIcon {
				width: 25px;
				padding-right: 10px;
			}
		}
	}
}
</style>